import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { CourseRepository } from '@/features/course/course/course.repository';
import { orderBy } from 'es-toolkit';
import { CourseSelectItem } from '@/types/course-select-item';

type CourseStatus = 'OPEN' | 'HIDE' | 'CLOSE' | string;

@Injectable({
    providedIn: 'root'
})
export class CourseService {
    readonly repository = inject(CourseRepository);

    selectItems = signal<CourseSelectItem[]>([]);

    async fetchAllName(): Promise<CourseSelectItem[]> {
        const courses = await firstValueFrom(this.repository.fetchNames(true));
        return orderBy(
            courses.map((c) => ({ label: c. label, value: c.value, status: c.status })),
            ['label'],
            ['asc']
        );
    }

    async lazyLoadSelectItems() {
        if (this.selectItems().length === 0) {
            const items = await this.fetchAllName();
            this.selectItems.set(items);
        }
        return this.selectItems();
    }

    getName(id: string): string {
        const items = this.selectItems();
        const found = items.find((item) => item.value === id);
        return found?.label ?? '';
    }
}
